import React from "react";

const SvgComponent = (props) => (
  <svg width={458} height={323} viewBox="0 0 458 323" fill="none" {...props}>
    <g id="prefix__Components" clipPath="url(#prefix__clip0)">
      <path
        transform="translate(-3326 -136)"
        fill="url(#prefix__paint0_linear)"
        d="M0 0h3884v1998H0z"
      />
      <g id="prefix__groupSvgSmall">
        <path
          id="dottedLine"
          className="dottedPaths"
          d="M58.112 19.663l342 .774c27.267.062 49.338 22.183 49.338 49.45V175c0 27.311-22.14 49.45-49.45 49.45H298.5c-8.257 0-14.95-6.693-14.95-14.95 0-8.864-7.186-16.05-16.05-16.05H58c-27.31 0-49.45-22.14-49.45-49.45V69.113c0-27.354 22.208-49.511 49.562-49.45z"
          stroke="#F0C5D6"
          strokeWidth={1.1}
        />
        <g id="prefix__extras">
          <path
            id="prefix__path34"
            d="M406.89 276.774c-2.7 0-4.89-2.187-4.89-4.887 0-2.7 2.19-4.887 4.89-4.887 2.7 0 4.89 2.187 4.89 4.887 0 2.7-2.19 4.887-4.89 4.887z"
            fill="#8F8ECB"
          />
          <path
            id="prefix__path38"
            d="M159.89 14.774A4.89 4.89 0 01155 9.887 4.89 4.89 0 01159.89 5a4.89 4.89 0 014.89 4.887 4.89 4.89 0 01-4.89 4.887z"
            fill="#F7B4C7"
          />
          <path
            id="prefix__path40"
            d="M76.803 49.602a3.802 3.802 0 110-7.602 3.802 3.802 0 110 7.602z"
            fill="#8F8ECB"
          />
          <path
            id="prefix__path42"
            d="M426.63 159.258a1.63 1.63 0 11-.001-3.259 1.63 1.63 0 01.001 3.259z"
            fill="#8F8ECB"
          />
          <path
            id="prefix__path46"
            d="M33.879 272.74a5.869 5.869 0 111.22-11.609 5.87 5.87 0 01-1.22 11.609"
            fill="#F7B4C7"
          />
          <path
            id="prefix__path48"
            d="M439.959 252.913a1.957 1.957 0 01-.004-3.913 1.954 1.954 0 011.917 2.364 1.96 1.96 0 01-1.913 1.549z"
            fill="#8F8ECB"
          />
        </g>
        <g id="prefix__chat">
          <path
            id="prefix__Vector_2"
            d="M449 83v28"
            stroke="#0B1726"
            strokeWidth={2}
          />
          <path
            id="prefix__path50"
            d="M441.093 122.614a3.87 3.87 0 01-2.747-1.157l-8.819-8.814a1.743 1.743 0 00-1.236-.512h-10.85c-3 0-5.441-2.439-5.441-5.436V86.437A5.446 5.446 0 01417.441 81h34.758c3 0 5.441 2.439 5.441 5.437v20.258a5.445 5.445 0 01-5.441 5.436h-5.409c-.964 0-1.749.785-1.749 1.749v4.805a3.86 3.86 0 01-2.421 3.621 3.99 3.99 0 01-1.527.308zm-23.652-39.442a3.27 3.27 0 00-3.268 3.265v20.258a3.27 3.27 0 003.268 3.264h10.85a3.9 3.9 0 012.773 1.148l8.819 8.814c.342.342.77.52 1.216.52.228 0 .461-.047.69-.142a1.698 1.698 0 001.079-1.614v-4.805a3.926 3.926 0 013.922-3.921h5.409a3.27 3.27 0 003.268-3.264V86.437a3.27 3.27 0 00-3.268-3.265h-34.758"
            fill="#F9FBFD"
          />
          <path
            id="prefix__path52"
            d="M424.497 100.005a3.263 3.263 0 01-3.26-3.258 3.263 3.263 0 013.26-3.258 3.263 3.263 0 013.26 3.258 3.263 3.263 0 01-3.26 3.258zm0-5.43a2.175 2.175 0 00-2.174 2.172c0 1.198.975 2.172 2.174 2.172a2.175 2.175 0 002.173-2.172 2.175 2.175 0 00-2.173-2.172z"
            fill="#F9FBFD"
          />
          <path
            id="prefix__path54"
            d="M434.82 100.548a3.263 3.263 0 01-3.26-3.258 3.263 3.263 0 013.26-3.258 3.263 3.263 0 013.26 3.258 3.263 3.263 0 01-3.26 3.258zm0-5.43a2.174 2.174 0 00-2.173 2.172c0 1.198.974 2.172 2.173 2.172a2.174 2.174 0 002.173-2.172 2.174 2.174 0 00-2.173-2.172z"
            fill="#F9FBFD"
          />
          <path
            id="prefix__path56"
            d="M444.6 100.548a3.263 3.263 0 01-3.26-3.258 3.263 3.263 0 013.26-3.258 3.263 3.263 0 013.26 3.258 3.263 3.263 0 01-3.26 3.258zm0-5.43a2.174 2.174 0 00-2.173 2.172c0 1.198.974 2.172 2.173 2.172a2.174 2.174 0 002.173-2.172 2.174 2.174 0 00-2.173-2.172z"
            fill="#F9FBFD"
          />
        </g>
        <g id="prefix__camera">
          <path
            id="prefix__Vector_3"
            d="M9.5 81v32"
            stroke="#0B1726"
            strokeWidth={3}
          />
          <path
            id="prefix__path66"
            d="M4.099 84.22a3.015 3.015 0 00-3.012 3.011v22.4a3.016 3.016 0 003.012 3.011h30.533a3.016 3.016 0 003.012-3.011v-22.4c0-1.66-1.352-3.01-3.012-3.01H4.1zm30.533 29.508H4.1A4.103 4.103 0 010 109.631v-22.4a4.102 4.102 0 014.099-4.096h30.533a4.102 4.102 0 014.099 4.096v22.4a4.103 4.103 0 01-4.099 4.097"
            fill="#fff"
          />
          <path
            id="prefix__path68"
            d="M38.647 104.262h.002-.002zm.084.022l10.028 2.672-.043-17.039-9.985 2.661v11.706zm10.123 2.699h.011-.01zm-.026 1.082l-.255-.033-10.203-2.72a.976.976 0 01-.726-.944V92.494c0-.44.298-.83.725-.943l10.204-2.72a.974.974 0 01.848.17.97.97 0 01.382.774v17.312c0 .307-.14.59-.383.775a.968.968 0 01-.592.203"
            fill="#fff"
          />
          <path
            id="prefix__path70"
            d="M12.723 83.971a.542.542 0 01-.544-.543v-2.342H5.884v2.342a.543.543 0 11-1.086 0v-2.452c0-.539.438-.976.977-.976h6.513c.54 0 .978.437.978.976v2.452c0 .301-.243.543-.543.543z"
            fill="#fff"
          />
          <path
            id="prefix__path72"
            d="M21.21 83.971a.543.543 0 01-.543-.543v-1.91h-5.186v1.91a.543.543 0 11-1.087 0v-2.084c0-.503.409-.912.912-.912h5.535c.503 0 .913.41.913.912v2.084c0 .301-.243.543-.543.543"
            fill="#fff"
          />
          <path
            id="prefix__path74"
            d="M18.628 89.57c-4.79 0-8.684 3.892-8.684 8.677 0 4.784 3.895 8.678 8.684 8.678 4.788 0 8.682-3.894 8.682-8.678 0-4.785-3.894-8.678-8.682-8.678zm0 18.441c-5.388 0-9.77-4.38-9.77-9.764 0-5.384 4.382-9.764 9.77-9.764 5.386 0 9.769 4.38 9.769 9.763 0 5.385-4.383 9.765-9.77 9.765z"
            fill="#fff"
          />
          <path
            id="prefix__path76"
            d="M17.325 94.55v7.392l4.837-3.695-4.837-3.697zm-.486 7.764l-.001.001.001-.001zm.185 1.025a.77.77 0 01-.348-.082.777.777 0 01-.438-.702v-8.617a.783.783 0 011.26-.622l5.638 4.308a.776.776 0 01.308.623.78.78 0 01-.308.623l-5.636 4.307a.79.79 0 01-.476.162"
            fill="#fff"
          />
          <path
            id="prefix__path78"
            d="M31.913 87.724c-.92 0-1.67.75-1.67 1.67a1.672 1.672 0 003.341 0c0-.92-.75-1.67-1.67-1.67zm0 4.426a2.758 2.758 0 01-2.757-2.755 2.76 2.76 0 012.757-2.757 2.76 2.76 0 012.758 2.757 2.759 2.759 0 01-2.758 2.755z"
            fill="#fff"
          />
          <path
            id="prefix__path80"
            d="M45.2 102.478a.542.542 0 01-.543-.543V91.607a.543.543 0 111.086 0v10.328c0 .3-.243.543-.543.543z"
            fill="#fff"
          />
        </g>
        <g id="prefix__guy1laptop">
          <path
            id="prefix__path320"
            d="M391.723 287.13l-298.596-.148.099-199.95a6.058 6.058 0 016.063-6.053l286.476.141a6.059 6.059 0 016.057 6.061l-.099 199.949"
            fill="#3C419F"
          />
          <path
            id="prefix__path324"
            d="M423.337 323.316l-362.296-.179c-3.93-.001-7.117-2.214-7.116-4.943l.004-7.786c0-.769.9-1.392 2.008-1.391l372.828.185c1.11 0 2.008.624 2.008 1.393l-.005 7.569c-.001 2.848-3.328 5.155-7.431 5.152"
            fill="#3C419F"
          />
          <path
            id="prefix__path326"
            d="M112.966 271.524l258.933.128a6.633 6.633 0 006.639-6.628l.079-160.923a6.633 6.633 0 00-6.631-6.633l-258.934-.128a6.633 6.633 0 00-6.637 6.626l-.08 160.924a6.633 6.633 0 006.631 6.634z"
            fill="#fff"
          />
          <path
            id="prefix__path328"
            d="M378.615 109.133l.002-5.032a6.632 6.632 0 00-6.631-6.633l-258.934-.128a6.633 6.633 0 00-6.637 6.627l-.003 5.05 272.203.116z"
            fill="#F17B99"
          />
          <path
            id="prefix__path330"
            d="M354.593 104.091a1.533 1.533 0 11-3.068-.002 1.533 1.533 0 013.068.002z"
            fill="#fff"
          />
          <path
            id="prefix__path332"
            d="M360.727 104.095a1.532 1.532 0 11-3.065-.003 1.532 1.532 0 013.065.003"
            fill="#fff"
          />
          <path
            id="prefix__path334"
            d="M366.861 104.098a1.533 1.533 0 01-1.535 1.531 1.532 1.532 0 11.001-3.065 1.534 1.534 0 011.534 1.534"
            fill="#fff"
          />
          <path
            id="prefix__path336"
            d="M353.168 249.147l-223.661-.11.06-120.824 81.652.04-5.524-.003-37.193-.017-.038 78.755 145.79.073.039-78.757-37.192-.018-27.085-.013 103.212.051-.06 120.823z"
            fill="#F4F7FC"
          />
          <path
            id="prefix__path338"
            d="M314.254 207.061l-145.79-.073.038-78.755 37.193.018-.02 38.574 71.406.036.02-38.575 37.192.018-.039 78.757"
            fill="#E5EEF9"
          />
          <path
            id="prefix__path340"
            d="M277.101 128.286l-27.085-.013 27.085.013zm-65.882-.032l-5.524-.003v-.001l5.524.004z"
            fill="#E5EEF9"
          />
          <path
            id="prefix__path342"
            d="M277.081 166.861l-71.406-.036.02-38.575 5.524.004c1.097.512 2.213.868 3.306 1.054l-2.215 25.06c-.003 6.769 5.485 12.258 12.258 12.262l8.136.004h.005c7.3 0 13.218-5.911 13.222-13.207l-2.19-23.899h.045c2.204 0 4.31-.447 6.23-1.255l27.085.013-.02 38.575z"
            fill="#D8E6F7"
          />
          <path
            id="prefix__path344"
            d="M430.774 309.408h-.956a2.706 2.706 0 00-1.052-.206l-372.83-.185h-.002c-.08 0-.157.003-.233.01l6.352-3.726.768.01-6.266 3.706 373.593.018.626.373"
            fill="#545CB3"
          />
          <path
            id="prefix__path346"
            d="M62.82 305.311l-.767-.01 25.422-14.914.564.002-25.218 14.922"
            fill="#545BB2"
          />
          <path
            id="prefix__path348"
            d="M88.04 290.389c-.194 0-.372-.001-.565-.003l5.804-3.404h.518l-5.758 3.407z"
            fill="#535AB2"
          />
          <path
            id="prefix__path350"
            d="M93.797 286.982h-.518l1-.587 26.73.022-26.383.075-.829.49"
            fill="#3C419F"
          />
          <path
            id="prefix__path352"
            d="M429.819 309.408l-374.73-.021.612-.36c.076-.006.153-.01.233-.01h.003l372.829.185c.385 0 .746.076 1.053.206z"
            fill="#3C419F"
          />
          <path
            id="prefix__path354"
            d="M430.425 309.034h-.277l-6.247-3.735.261-.006 6.263 3.741"
            fill="#5360B6"
          />
          <path
            id="prefix__path356"
            d="M423.901 305.299l-23.858-14.263h.254l23.865 14.257-.261.006z"
            fill="#525FB5"
          />
          <path
            id="prefix__path358"
            d="M400.043 291.036l-7.354-4.396-.965-.001v-.724l8.573 5.121h-.254z"
            fill="#525FB5"
          />
          <path
            id="prefix__path360"
            d="M391.724 286.639l-270.715-.222 270.277-.764.438.261v.725"
            fill="#4C5AB2"
          />
          <path
            id="prefix__path362"
            d="M430.148 309.034l-373.593-.017 6.266-3.707c56.392.73 133.262 1.411 207.574 1.412 55.85 0 110.275-.385 153.506-1.423l6.247 3.735z"
            fill="#4F5DB3"
          />
          <path
            id="prefix__path364"
            d="M270.395 306.722c-74.312-.001-151.182-.682-207.574-1.412l25.218-14.921c90.579.367 224.568.647 309.945.647h2.059l23.858 14.263c-43.231 1.038-97.656 1.423-153.506 1.423z"
            fill="#4F5DB3"
          />
          <path
            id="prefix__path366"
            d="M397.984 291.036c-85.377 0-219.366-.28-309.945-.647l5.758-3.407 297.926.148.001-.491.965.001 7.354 4.396h-2.059"
            fill="#4F5DB3"
          />
          <path
            id="prefix__path368"
            d="M391.723 287.13l-297.926-.148.83-.49 26.382-.075 270.715.222-.001.491z"
            fill="#4C5AB2"
          />
          <path
            id="prefix__path370"
            d="M114.146 290.584a5.238 5.238 0 00-3.075.996l-16.578 12.026 297.999.055-15.329-11.014a10.011 10.011 0 00-5.835-1.882l-257.182-.181z"
            fill="#3C419F"
          />
        </g>
        <g id="prefix__guy1">
          <path
            id="prefix__path372"
            d="M314.85 208.777l12.625 18.29c.216.218-.178-.91 0-1.16l19.807-32.444-.059-.025 1.725-2.706 6.245-10.231c-4.5-4.721-5.614-14.886-5.584-14.866l-2.208-6.954c-.398-1.257.143-2.69 1.354-3.212a2.524 2.524 0 013.413 1.551l2.086 6.618c.344 1.096 1.891 1.202 2.343.146.658-1.536.662-3.335.488-4.785l-3.805-17.953a2.523 2.523 0 011.949-2.987c1.419.001 2.817 1.136 3.111 2.523l2.626 12.468c.118.558.61.956 1.18.956h.392c.66 0 1.209-.513 1.254-1.172l1.087-15.935c.091-1.316 1.121-2.45 2.439-2.492a2.522 2.522 0 012.606 2.691l-1.059 15.502a1.65 1.65 0 001.277 1.718c1.008.23 2.014-.4 2.245-1.409l3.093-13.531c.294-1.287 1.487-2.246 2.797-2.082a2.522 2.522 0 012.155 3.064l-3.216 14.063a4.438 4.438 0 00.269 2.788c.457 1.033 1.917 1.051 2.398.029l2.774-5.871c.563-1.193 1.935-1.875 3.179-1.432a2.52 2.52 0 011.446 3.454l-5.772 12.938c-4.27 11.648-8.894 18.423-10.49 20.57l-5.247 10.999-1.144 2.509-.045-.019-27.117 56.83c-4.235 8.874-15.959 10.93-22.963 4.028l-23.013-26.078 23.359-26.391"
            fill="#F9D8D0"
          />
          <path
            id="prefix__path376"
            d="M283.462 235.035l7.312 2.44 28.162-30.391c-20.501-38.659-45.729-53.241-60.379-58.676-5.723-2.124-11.786-3.161-17.89-3.164l-20.395-.009c-5.519-.003-11.026.884-16.181 2.853-44.562 17.021-60.793 85.659-60.793 85.659l6.045 1.007 29.298 4.886-.016 31.428 104.82.052.017-36.085z"
            fill="#F17B99"
          />
          <path
            id="prefix__path378"
            d="M178.208 239.639l-28.629-4.617-.017 36.032 28.631.014.015-31.429z"
            fill="#F9D8D0"
          />
          <path
            id="prefix__path384"
            d="M271.428 56.471c-6.124-13.42-16.993-7.996-16.993-7.996-3.13-7.919-12.01-17.298-24.295-18.37-8.946-.78-13.378 2.998-16.33 4.084-6.947-3.89-13.785-4.078-18.772 1.239-7.326 7.81-4.356 14.878-2.423 17.892.545 1.17 3.161 5.2 5.525 6.507-4.017 9.53-7.193 25.153 14.226 26.638l44.806 2.27s3.424-2.89 7.059-7.298c5.353-6.49 11.168-16.269 7.197-24.966"
            fill="#322E44"
          />
          <path
            id="prefix__path386"
            d="M264.231 81.438c-3.635 4.407-7.059 7.297-7.059 7.297l-1.528-17.107c-6.64-.478-8.323-5.16-8.426-9.516l-11.384-.058c-16.275 2.054-30.239-.348-33.369-.957l-.731.057a1.104 1.104 0 01-.356.427l-.008 18.843h-.753c-4.896-.002-8.865 3.961-8.867 8.853v.962c-.004 4.89 3.963 8.86 8.857 8.861l.753.001-.007 12.815c-.005 9.778 6.944 16.331 13.172 17.392l-2.215 25.06c-.003 6.769 5.485 12.259 12.258 12.262l8.136.004c7.301.004 13.223-5.91 13.227-13.207l-2.19-23.898h.037c8.887.004 16.161-7.258 16.165-16.139l.008-14.26h.229c4.894.002 8.865-3.962 8.867-8.853v-.962c.003-3.435-1.957-6.407-4.816-7.877"
            fill="#F9D8D0"
          />
          <path
            id="prefix__path388"
            d="M244.609 140.506l-29.335-11.179a9.47 9.47 0 001.798.189l26.456.013 1.081 10.977"
            fill="#F7BFC0"
          />
          <path
            id="prefix__path392"
            d="M265.642 89.85a.373.373 0 00.373-.372c.002-4.026-3.718-4.075-3.756-4.075a.372.372 0 10-.001.746c.123.002 3.012.057 3.01 3.328 0 .206.167.374.374.374z"
            fill="#F17B99"
          />
          <path
            id="prefix__path394"
            d="M194.883 89.816a.372.372 0 01-.372-.374c.002-4.025 3.722-4.07 3.76-4.07a.373.373 0 01.001.746c-.124 0-3.013.053-3.015 3.325a.373.373 0 01-.374.373"
            fill="#F17B99"
          />
          <path
            id="prefix__path396"
            d="M215.231 89.382c-.88 0-1.594-.714-1.593-1.593l.001-3.187a1.595 1.595 0 013.189.001l-.002 3.187a1.593 1.593 0 01-1.595 1.592"
            fill="#100F0D"
          />
          <path
            id="prefix__path398"
            d="M239.682 89.394a1.595 1.595 0 01-1.593-1.594l.001-3.186a1.596 1.596 0 013.19.001l-.002 3.186c0 .88-.715 1.593-1.596 1.593"
            fill="#100F0D"
          />
          <path
            id="prefix__path400"
            d="M221.157 77.164c-.738.51-1.756.494-2.737.552-.993.031-1.986.095-2.846.189-.863.09-1.85.24-2.827.421-.973.153-1.973.383-2.78.041-.778-.316-1.186-1.417-.442-2.906.696-1.448 2.708-3.155 5.562-3.47 2.852-.298 5.109.95 6.027 2.223.974 1.305.754 2.473.043 2.95z"
            fill="#322E44"
          />
          <path
            id="prefix__path402"
            d="M247.891 79.799c-.945.269-1.96-.075-2.968-.335a40.136 40.136 0 00-2.928-.734 41.362 41.362 0 00-3.004-.493c-1.037-.163-2.134-.256-2.803-.86-.651-.567-.614-1.8.735-3.046 1.283-1.221 3.992-2.275 6.98-1.666 2.98.625 4.737 2.604 5.142 4.173.447 1.618-.248 2.715-1.154 2.96"
            fill="#322E44"
          />
          <path
            id="prefix__path404"
            d="M215.072 90.055c.87 0 1.893-.187 3.006-.743a.58.58 0 00-.518-1.038c-2.697 1.349-4.687.087-4.769.033a.582.582 0 00-.803.165.578.578 0 00.16.801c.07.047 1.2.781 2.924.782"
            fill="#F17B99"
          />
          <path
            id="prefix__path406"
            d="M239.523 90.067c.87 0 1.893-.187 3.006-.743a.579.579 0 10-.518-1.037c-2.698 1.348-4.687.086-4.769.031a.583.583 0 00-.803.167.577.577 0 00.16.8c.07.047 1.2.78 2.924.782"
            fill="#F17B99"
          />
          <path
            id="prefix__path408"
            d="M228.992 99.697l6.242.004a.471.471 0 00.001-.942l-6.243-.003a4.263 4.263 0 01-4.256-4.256l.001-1.178c0-.672.547-1.217 1.219-1.217 1.969.001 3.192-1.47 3.193-3.842l.183-6.048a.475.475 0 00-.458-.485c-.243.007-.477.197-.484.457l-.183 6.062c0 .695-.163 2.916-2.251 2.915-1.19 0-2.16.967-2.16 2.156l-.001 1.179a5.205 5.205 0 005.197 5.198"
            fill="#F17B99"
          />
          <path
            id="prefix__path410"
            d="M226.779 122.3l-2.588-.001a2.274 2.274 0 01-2.274-2.273l.004-6.047 14.272-3.559-.001 2.483c-.002 5.192-4.217 9.4-9.413 9.397"
            fill="#fff"
          />
          <path
            id="prefix__path412"
            d="M213.405 78.275c-5.395-.003-9.786 4.381-9.788 9.771-.002 5.39 4.384 9.778 9.778 9.782 5.394.002 9.784-4.381 9.786-9.772.004-5.391-4.382-9.779-9.776-9.78zm-.01 20.639c-5.994-.004-10.868-4.879-10.865-10.868.002-5.99 4.882-10.86 10.875-10.857 5.993.002 10.866 4.879 10.863 10.868-.003 5.99-4.88 10.859-10.873 10.857z"
            fill="#3C419F"
          />
          <path
            id="prefix__path414"
            d="M243.768 77.19a9.73 9.73 0 00-6.919 2.86 9.709 9.709 0 00-2.867 6.911 9.712 9.712 0 002.861 6.915 9.72 9.72 0 006.915 2.866 9.721 9.721 0 006.92-2.86 9.712 9.712 0 002.868-6.911 9.71 9.71 0 00-2.862-6.915 9.726 9.726 0 00-6.916-2.867zm-.01 20.638a10.797 10.797 0 01-7.683-3.186 10.78 10.78 0 01-3.18-7.682 10.782 10.782 0 013.187-7.678 10.8 10.8 0 017.687-3.179 10.803 10.803 0 017.683 3.186 10.786 10.786 0 013.181 7.682 10.793 10.793 0 01-3.188 7.679 10.8 10.8 0 01-7.687 3.178"
            fill="#3C419F"
          />
          <path
            id="prefix__path416"
            d="M223.399 86.06a.544.544 0 01-.338-.97c.058-.046 6.03-4.688 10.762.047a.543.543 0 11-.768.768c-4.056-4.055-9.105-.132-9.318.037a.55.55 0 01-.338.117"
            fill="#3C419F"
          />
        </g>
        <g id="prefix__userPlus">
          <g id="prefix__userIcon">
            <path
              id="prefix__path418"
              d="M105.574 177.694c0 11.518-9.342 20.854-20.866 20.854s-20.867-9.336-20.867-20.854c0-11.517 9.343-20.853 20.867-20.853 11.524 0 20.866 9.336 20.866 20.853z"
              fill="#fff"
            />
            <path
              id="prefix__path420"
              d="M84.708 158.68c-10.49 0-19.026 8.53-19.026 19.015 0 10.483 8.535 19.013 19.026 19.013 10.49 0 19.025-8.53 19.025-19.013 0-10.485-8.535-19.015-19.025-19.015zm0 41.707c-12.52 0-22.708-10.179-22.708-22.692C62 165.181 72.188 155 84.708 155c12.522 0 22.707 10.181 22.707 22.695 0 12.513-10.185 22.692-22.707 22.692z"
              fill="#F17B99"
            />
            <path
              id="prefix__path422"
              d="M91.966 170.388a7.256 7.256 0 01-7.258 7.253 7.256 7.256 0 01-7.259-7.253 7.256 7.256 0 017.259-7.254 7.256 7.256 0 017.258 7.254z"
              fill="#F17B99"
            />
            <path
              id="prefix__path424"
              d="M96.956 184.895c0 4.006-5.485 7.253-12.248 7.253-6.764 0-12.248-3.247-12.248-7.253 0-4.007 5.484-7.254 12.248-7.254 6.763 0 12.248 3.247 12.248 7.254z"
              fill="#F17B99"
            />
          </g>
          <g id="prefix__plus" fill="#F17B99">
            <path
              id="prefix__path426"
              d="M69.882 152.881H58.63a1.629 1.629 0 110-3.258h11.252a1.629 1.629 0 110 3.258z"
            />
            <path
              id="prefix__path428"
              d="M64.257 158.503c-.901 0-1.63-.728-1.63-1.629v-11.245a1.629 1.629 0 113.26 0v11.245c0 .901-.73 1.629-1.63 1.629z"
            />
          </g>
        </g>
        <g id="prefix__userPlus_2">
          <g id="prefix__userIcon2">
            <path
              id="prefix__path430"
              d="M340.693 20.213c0 9.328-7.567 16.89-16.9 16.89-9.334 0-16.899-7.562-16.899-16.89 0-9.327 7.565-16.888 16.899-16.888 9.333 0 16.9 7.561 16.9 16.888"
              fill="#fff"
            />
            <path
              id="prefix__path432"
              d="M323.794 4.814c-8.497 0-15.41 6.909-15.41 15.4 0 8.49 6.913 15.398 15.41 15.398 8.496 0 15.408-6.908 15.408-15.398 0-8.491-6.912-15.4-15.408-15.4zm0 33.779c-10.141 0-18.392-8.244-18.392-18.379 0-10.134 8.251-18.38 18.392-18.38s18.39 8.246 18.39 18.38c0 10.135-8.249 18.379-18.39 18.379z"
              fill="#6C92D3"
            />
            <path
              id="prefix__path434"
              d="M329.671 14.296a5.876 5.876 0 01-5.878 5.874 5.876 5.876 0 01-5.878-5.874 5.877 5.877 0 015.878-5.874 5.877 5.877 0 015.878 5.874z"
              fill="#6C92D3"
            />
            <path
              id="prefix__path436"
              d="M333.712 26.045c0 3.244-4.441 5.874-9.919 5.874-5.478 0-9.919-2.63-9.919-5.874 0-3.245 4.441-5.875 9.919-5.875 5.478 0 9.919 2.63 9.919 5.875z"
              fill="#6C92D3"
            />
          </g>
          <g id="prefix__plus2" fill="#6C92D3">
            <path
              id="prefix__path438"
              d="M306.744 7.813h-9.114a1.63 1.63 0 110-3.258h9.114a1.63 1.63 0 110 3.258z"
            />
            <path
              id="prefix__path440"
              d="M302.187 12.366c-.9 0-1.63-.729-1.63-1.629V1.63a1.63 1.63 0 013.26 0v9.108c0 .9-.731 1.63-1.63 1.63z"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="prefix__paint0_linear"
        x1={1942}
        y1={999}
        x2={3884}
        y2={999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop stopColor="#0B1726" />
      </linearGradient>
      <clipPath id="prefix__clip0">
        <path
          fill="#fff"
          transform="translate(-3326 -136)"
          d="M0 0h3884v1998H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
